import React, { useEffect, useRef } from "react";
import { ListGroup } from "react-bootstrap";
import logo from "../Assets/images/avatar_.png";
import { IMessage } from "../@types/VideoCallTypes";

type Props = {
  comments: IMessage[];
};

const LiveComments: React.FC<Props> = ({ comments }) => {
  const endRef = useRef<HTMLDivElement | null>(null);

  // ✅ Auto-scroll to latest comment
  // useEffect(() => {
  //   if (endRef.current) {
  //     endRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [comments]);
console.log("comments===>",comments);
  return (
    <div className="live-comments comments--wraper">
      <ListGroup variant="flush">
        {comments.map((comment, index) => (
          <ListGroup.Item key={index} className="comment-item">
            <div className="d-flex align-items-center">
              <img
                src={
                  comment.user.profilePicture
                    ? comment.user.profilePicture
                    : logo
                }
                alt={comment.user.fullName}
                width={35}
                height={35}
                className="rounded-circle me-2 m--comment--img"
              />
              <div>
                <div className="comment-userw-name">{comment.user.fullName}</div>
                <div className="comment--text">{comment.text}</div>
              </div>
            </div>
          </ListGroup.Item>
        ))}
        <div ref={endRef} />
      </ListGroup>
    </div>
  );
};

export default LiveComments;
